import createVueApp from '@phoenix/createVueApp';
import LegacyBackgroundVideo from '@maison/components/molecules/LegacyBackgroundVideo.vue';

document.querySelectorAll('.phoenix-legacy-background-video').forEach((el) => {
  const app = createVueApp({}, false);
  app.component('LegacyBackgroundVideo', LegacyBackgroundVideo);
  app.mount(el);
});
